const HELP_LINKS = {
  integrations: {
    integrationsHub:
      'https://intercom.help/ad-up/en/collections/12244904-data-integration-guide',
  },

  reports: {
    notifications:
      'https://intercom.help/ad-up/en/collections/15185481-reporting',
    presentations:
      'https://intercom.help/ad-up/en/articles/12182230-set-up-your-google-slides',
    prompts: 'https://intercom.help/ad-up/en/articles/12182401-custom-prompts',
    graphs: 'https://intercom.help/ad-up/en/collections/15185481-reporting',
  },

  settings: {
    general:
      'https://intercom.help/ad-up/en/collections/13474403-adup-settings',
    profile:
      'https://intercom.help/ad-up/en/collections/13474403-adup-settings',
    shops: 'https://intercom.help/ad-up/en/collections/13474403-adup-settings',
    brands: 'https://intercom.help/ad-up/en/collections/13474403-adup-settings',
    communication:
      'https://intercom.help/ad-up/en/collections/13474403-adup-settings',
    apiKeys:
      'https://intercom.help/ad-up/en/collections/13474403-adup-settings',
    subscription:
      'https://intercom.help/ad-up/en/articles/11660671-adup-business-vs-agency-account-feature-comparison',
  },
};

export default HELP_LINKS;
